"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createServiceLocator = exports.initBaseServices = void 0;
var client_builder_1 = __importDefault(require("@gin-betting/client-builder"));
var ServiceLocator_1 = require("./ServiceLocator");
var utils_1 = require("./utils");
var api_1 = __importStar(require("./api"));
var async_1 = require("./async");
var createLink = client_builder_1.default.utils.createLink;
function initBaseServices(serviceLocator) {
    serviceLocator.set('apolloLink', function () {
        var _a = utils_1.getBettingOptions(), token = _a.token, url = _a.url;
        return createLink({
            endpoint: url.gqlEndpoint + "/graphql",
            token: token,
        });
    });
    serviceLocator.set('apiClient', function () {
        var apiClientFactory = new api_1.ApiClientFactory();
        var link = serviceLocator.get('apolloLink');
        return apiClientFactory.make(link);
    });
    serviceLocator.set('apiMiddleware', function () {
        return api_1.default.createApiMiddleware(serviceLocator.get('apiClient'));
    });
    serviceLocator.set('subscriptionManager', function () {
        var subscriptionManagerFactory = new async_1.SubscriptionManagerFactory();
        return subscriptionManagerFactory.make(serviceLocator.get('apiClient'));
    });
    serviceLocator.set('subscriptionMiddleware', function () {
        return async_1.createSubscriptionMiddleware(serviceLocator.get('subscriptionManager'));
    });
}
exports.initBaseServices = initBaseServices;
function createServiceLocator() {
    return new ServiceLocator_1.ServiceLocator(initBaseServices);
}
exports.createServiceLocator = createServiceLocator;
exports.default = createServiceLocator();
//# sourceMappingURL=appServiceLocator.js.map